import React from "react";
import { useCurrentUser } from "../../hooks/currentUser";

export const Logo = () => {
  const { currentUser } = useCurrentUser();
  const getLogoUrl = () => {
    return "/logo512.png";
  };

  const getLogoAlt = () => {
    return "Sajor Table Top";
  };

  if (!currentUser) {
    return null;
  }

  return (
    <a href="/">
      <img
        src={getLogoUrl()}
        alt={getLogoAlt()}
        style={{ marginLeft: "5px", maxHeight: "40px" }}
      ></img>
    </a>
  );
};
